export enum VariantEnum {
  vertical = 'vertical',
  horizontal = 'horizontal',
}

export type Variant = keyof typeof VariantEnum;
